import { EVENTS } from '../../bus/events.const';
import { WIRES } from '../wires';
import { Wiring } from '../wiring.interfaces';

export const QUERY_SIGNALS_WIRING: Wiring = {
  [EVENTS.ToggleRelatedTag]: [
    WIRES.queryOriginRelatedTag,
    WIRES.toggleRelatedTag,
    WIRES.search,
    WIRES.getTermSuggestions,
    WIRES.emitUserAcceptedQuery
  ],
  [EVENTS.ApplyRelatedTag]: [
    WIRES.queryOriginRelatedTag,
    WIRES.applyRelatedTag,
    WIRES.getTermSuggestions,
    WIRES.emitUserAcceptedQuery
  ],
  [EVENTS.SelectNextQuery]: [
    WIRES.queryOriginNextQuery,
    WIRES.emitApplyNextQuery
  ],
  [EVENTS.ApplyNextQuery]: [
    WIRES.applyNextQuery,
    WIRES.getTermSuggestions,
    WIRES.getIdentifierSuggestions,
    WIRES.blurSearchInput,
    WIRES.scrollToTop,
    WIRES.emitUserAcceptedQuery
  ],
  [EVENTS.NextQueriesLoadSuccess]: [
    WIRES.saveNextQueriesState,
    WIRES.loadNextQueriesResultsIfEnabled
  ],
  [EVENTS.RelatedTagsLoadSuccess]: [
    WIRES.saveRelatedTags
  ]
};
